import { useCallback, useEffect, useState } from 'react';
import { lambdaOperationsApi, LambdaOperation } from '@api/lambdaOperationsApi';
import { isErrorResponse } from '@utils/utils';
import { ApiError } from '@api/RestClient';

export const useLambdaOperations = () => {
    const [operations, setOperations] = useState<LambdaOperation[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<ApiError | null>(null);

    const loadOperations = useCallback(async (abortSignal: AbortSignal) => {
        setLoading(true);
        const resp = await lambdaOperationsApi.getAvailableOperations(abortSignal);

        if (isErrorResponse(resp)) {
            setError(resp);
            setOperations([]);
        } else {
            setError(null);
            setOperations(Array.isArray(resp) ? resp : []);
        }

        setLoading(false);
    }, []);

    useEffect(() => {
        const abortController = new AbortController();
        void loadOperations(abortController.signal);

        return () => abortController.abort();
    }, [loadOperations]);

    const retry = useCallback(() => {
        const abortController = new AbortController();
        void loadOperations(abortController.signal);
    }, [loadOperations]);

    return { operations, loading, error, retry };
};
